import runTippy from 'tippy.js';
/**
 * Svelte action for rendering a [Tippy.JS](https://atomiks.github.io/tippyjs/) tooltip
 *
 * @example
 * ```svelte
 * <script lang="ts">
 *   import {tippy} from './tippy';
 *   import 'tippy.js/dist/tippy.css'; // optional
 * </script>
 * <button use:tippy={{content: 'Test'}}>Test</button>
```
 * @param element The element to target (omitted with use)
 * @param props [Tippy.js Props](https://atomiks.github.io/tippyjs/v6/all-props/)
 */
export const tippy = (element, props) => {
    const { destroy, setProps: update } = runTippy(element, props);
    return {
        destroy,
        update
    };
};
/**
 * @example
 * ```svelte
 * <script lang="ts">
 *   import {tippy} from './tippy';
 *   const tippy = createTippy({
 *    arrow: false,
 *    offset: [0, 10],
 *    animateFill: true,
 *    delay: 10
 * })
 * </script>
 * <button use:tippy={{content: 'Test'}}>Test</button>
 * ```
 * ------------------------------------------
 * @param defaultProps The default properties to pass to tippy.js see [tippy.js props](https://atomiks.github.io/tippyjs/v6/all-props/)
 * @returns A svelte action for rendering the tippy.js tooltip
 */
export const createTippy = defaultProps => (element, props) => tippy(element, { ...props, ...defaultProps });
